<template>
  <span aria-hidden="true" class="d-none" />
</template>

<script>
import introJs from 'intro.js'
import 'intro.js/introjs.css'
import eventBus from '../helpers/event.bus'
import notificacaoCacheService from '../helpers/notificacao.cache.service'
import Helper from '../helpers/helper.service'
import userService from '../helpers/user.service'
import { router } from '../router'
import {
  TOUR_NOTIFICACOES_ENCERRAR,
  TOUR_NOTIFICACOES_INICIAR,
  TOUR_NOTIFICACOES_PREPARAR_DESKTOP,
  TOUR_NOTIFICACOES_PREPARAR_MOBILE,
  aguardarElementoTourNotificacoes,
  estaNaRotaTourNotificacoesAluno,
  seletorAlvoTourNotificacoes,
  tourDisponivelNotificacoes,
  usarLayoutNotificacoesMobileHeader,
} from '../helpers/helper.notificacao.tour'

export default {
  name: 'TourNotificacoesOverlay',
  data() {
    return {
      tourInstance: null,
      tourFinalizado: false,
      tourIniciando: false,
      tourIrParaMensagensAoConcluir: false,
      onIniciar: null,
    }
  },
  mounted() {
    this.onIniciar = (event) => this.iniciar(event)
    eventBus.addEventListener(TOUR_NOTIFICACOES_INICIAR, this.onIniciar)
  },
  beforeUnmount() {
    eventBus.removeEventListener(TOUR_NOTIFICACOES_INICIAR, this.onIniciar)
    this.destruirTour(true)
  },
  methods: {
    idiomaIntroJs() {
      const locale = (Helper.currentLocale() || 'pt-BR').toLowerCase()
      if (locale.startsWith('pt'))
        return 'pt_BR'
      if (locale.startsWith('es'))
        return 'es_ES'
      return 'en_US'
    },
    async aguardarLayoutDropdownNotificacoes() {
      await this.$nextTick()
      await new Promise((resolve) => {
        requestAnimationFrame(() => requestAnimationFrame(resolve))
      })
      await new Promise((resolve) => setTimeout(resolve, 160))
    },
    async iniciar(event) {
      const mensagens = event?.detail?.mensagens ?? 0
      const notificacoes = event?.detail?.notificacoes ?? 0

      if (this.tourIniciando || this.tourInstance || document.body.classList.contains('tour-notificacoes-ativo'))
        return

      if (!tourDisponivelNotificacoes())
        return

      if (!estaNaRotaTourNotificacoesAluno({ path: window.location.pathname }))
        return

      if (mensagens <= 0 && notificacoes <= 0)
        return

      this.tourIniciando = true

      try {
        notificacaoCacheService.notificarContagensAtualizadas(mensagens, notificacoes)

        document.body.classList.add('tour-notificacoes-ativo')

        const seletorAlvo = seletorAlvoTourNotificacoes()
        if (usarLayoutNotificacoesMobileHeader())
          eventBus.dispatchEvent(new CustomEvent(TOUR_NOTIFICACOES_PREPARAR_MOBILE))
        else
          eventBus.dispatchEvent(new CustomEvent(TOUR_NOTIFICACOES_PREPARAR_DESKTOP))

        await this.aguardarLayoutDropdownNotificacoes()

        const alvo = await aguardarElementoTourNotificacoes(seletorAlvo)
        if (!alvo) {
          this.finalizarTour()
          return
        }

        this.tourFinalizado = false
        this.tourInstance = introJs.tour()

        this.tourInstance.setOptions({
          steps: [{
            element: alvo,
            intro: this.$t('notificationTour.desktopMessage'),
            position: 'bottom-right-aligned',
            tooltipClass: 'tour-notificacoes-intro-tooltip',
            highlightClass: 'tour-notificacoes-intro-highlight',
          }],
          showBullets: false,
          showProgress: false,
          showStepNumbers: false,
          hidePrev: true,
          nextToDone: true,
          doneLabel: this.$t('notificationTour.close'),
          exitOnOverlayClick: false,
          exitOnEsc: true,
          scrollToElement: false,
          disableInteraction: false,
          helperElementPadding: 8,
          overlayOpacity: 0.55,
          language: this.idiomaIntroJs(),
        })

        this.tourIrParaMensagensAoConcluir = false
        this.tourInstance.onExit(() => this.aoEncerrarTour())

        await this.tourInstance.start()
        this.tourInstance.disableRefreshOnResize?.()
        this.adicionarBotaoConferirTour()
      } finally {
        this.tourIniciando = false
      }
    },
    rotaMensagensAluno() {
      return userService.getRotaMensagens()
    },
    adicionarBotaoConferirTour() {
      const tooltip = document.querySelector('.introjs-tooltip.tour-notificacoes-intro-tooltip')
      const botoes = tooltip?.querySelector('.introjs-tooltipbuttons')
      if (!botoes || botoes.querySelector('[data-tour-conferir]'))
        return

      const fechar = botoes.querySelector('.introjs-donebutton, .introjs-nextbutton')
      if (fechar)
        fechar.textContent = this.$t('notificationTour.close')

      const conferir = document.createElement('button')
      conferir.type = 'button'
      conferir.dataset.tourConferir = '1'
      conferir.className = 'introjs-button introjs-nextbutton tour-notificacoes-btn-conferir'
      conferir.textContent = this.$t('notificationTour.check')
      conferir.addEventListener('click', () => {
        if (!this.tourInstance)
          return
        this.tourIrParaMensagensAoConcluir = true
        this.tourInstance.exit()
      })

      botoes.appendChild(conferir)
    },
    aoEncerrarTour() {
      const irParaMensagens = this.tourIrParaMensagensAoConcluir
      this.tourIrParaMensagensAoConcluir = false
      this.finalizarTour()
      if (irParaMensagens)
        router.push(this.rotaMensagensAluno())
    },
    finalizarTour() {
      if (this.tourFinalizado)
        return
      this.tourFinalizado = true
      this.destruirTour(false)
      document.body.classList.remove('tour-notificacoes-ativo')
      eventBus.dispatchEvent(new CustomEvent(TOUR_NOTIFICACOES_ENCERRAR))
    },
    destruirTour(forcarSaida) {
      if (!this.tourInstance)
        return

      try {
        if (forcarSaida)
          this.tourInstance.exit(true)
      } catch {
        // tour já encerrado
      }

      this.tourInstance = null
    },
  },
}
</script>

<style>
body.tour-notificacoes-ativo {
  overflow: hidden;
}

body.tour-notificacoes-ativo .header-page .header-fixed {
  z-index: 1060;
}

body.tour-notificacoes-ativo .header-page .header-navbar-rht .noti-nav.noti-nav--tour {
  position: relative;
  z-index: 1070;
}

body.tour-notificacoes-ativo .header-page .header-navbar-rht .noti-nav.noti-nav--tour .notifications.dropdown-menu {
  display: block;
  z-index: 1071;
}

body.tour-notificacoes-ativo .header-page #header-notificacoes-nav-mobile.noti-nav--tour {
  position: relative;
  z-index: 1070;
}

body.tour-notificacoes-ativo .introjs-overlay,
body.tour-notificacoes-ativo .introjs-helperLayer,
body.tour-notificacoes-ativo .introjs-tooltipReferenceLayer {
  z-index: 1080 !important;
}

body.tour-notificacoes-ativo .introjs-tour {
  --introjs-fade-opacity: 1;
}

body.tour-notificacoes-ativo .introjs-overlay,
body.tour-notificacoes-ativo .introjs-helperLayer,
body.tour-notificacoes-ativo .introjs-tooltipReferenceLayer,
body.tour-notificacoes-ativo .introjs-tooltip {
  transition: none !important;
  animation: none !important;
}

body.tour-notificacoes-ativo .introjs-tooltip.tour-notificacoes-intro-tooltip {
  max-width: min(380px, calc(100vw - 32px));
}

body.tour-notificacoes-ativo .introjs-tooltipbuttons .introjs-button.introjs-donebutton,
body.tour-notificacoes-ativo .introjs-tooltipbuttons .introjs-button.introjs-nextbutton {
  background-color: #258f71;
  border-color: #258f71;
  color: #fff;
  text-shadow: none;
}

body.tour-notificacoes-ativo .introjs-tooltipbuttons .introjs-button.introjs-donebutton:hover,
body.tour-notificacoes-ativo .introjs-tooltipbuttons .introjs-button.introjs-nextbutton:hover {
  background-color: #1f7a61;
  border-color: #1f7a61;
}

body.tour-notificacoes-ativo .introjs-tooltip.tour-notificacoes-intro-tooltip .introjs-skipbutton {
  display: none !important;
}

body.tour-notificacoes-ativo .introjs-tooltip.tour-notificacoes-intro-tooltip .introjs-tooltip-header {
  min-height: 0;
  padding: 0;
  border: none;
}

body.tour-notificacoes-ativo .introjs-tooltip.tour-notificacoes-intro-tooltip .introjs-tooltipbuttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding-top: 12px;
}

body.tour-notificacoes-ativo .introjs-tooltip.tour-notificacoes-intro-tooltip .introjs-donebutton {
  background: #fff;
  border: 1px solid #d0d5dd;
  color: #344054;
  text-shadow: none;
  order: 1;
}

body.tour-notificacoes-ativo .introjs-tooltip.tour-notificacoes-intro-tooltip .introjs-donebutton:hover {
  background: #f9fafb;
  border-color: #98a2b3;
  color: #344054;
}

body.tour-notificacoes-ativo .introjs-tooltip.tour-notificacoes-intro-tooltip .tour-notificacoes-btn-conferir {
  order: 2;
}
</style>
